/**
 * Distillery API Types
 * Types for the Distillery service that manages AI bot agents for ZEEF chat
 */

// Agent status response when no agent exists
export interface AgentNotExistsResponse {
  exists: false
  organization_id: string
}

// Agent status response when agent exists
export interface AgentExistsResponse {
  exists: true
  id: number
  organization_id: string
  cognito_username: string
  is_active: boolean
  connection_status: AgentConnectionStatus
  created_at: string
}

// Union type for agent status check
export type AgentStatusResponse = AgentNotExistsResponse | AgentExistsResponse

// Agent creation response
export interface AgentCreateResponse {
  id: number
  organization_id: string
  cognito_username: string
  status: "created"
}

// Agent connection response
export interface AgentConnectResponse {
  status: "connected"
  organization_id: string
  connection_status: "connected"
}

// Agent disconnect response
export interface AgentDisconnectResponse {
  status: "disconnected"
  organization_id: string
  connection_status: "disconnected"
}

// Agent toggle response
export interface AgentToggleResponse {
  status: "toggled"
  organization_id: string
  is_active: boolean
}

// Agent delete response
export interface AgentDeleteResponse {
  status: "deleted"
}

// Detailed agent status response
export interface AgentDetailedStatusResponse {
  exists: boolean
  id?: number
  organization_id: string
  cognito_username?: string
  is_active?: boolean
  db_connection_status?: AgentConnectionStatus
  live_connection_status?: AgentConnectionStatus
  is_actually_connected?: boolean
  created_at?: string
}

// Connection status enum
export type AgentConnectionStatus = "connected" | "disconnected" | "connecting" | "error"

// Error response from Distillery API
export interface DistilleryErrorResponse {
  detail: string
}

// Type guard to check if agent exists
export function agentExists(response: AgentStatusResponse): response is AgentExistsResponse {
  return response.exists === true
}
